
export const getReportsFromPath = (pathname: string) => {
    const matches = pathname.match(/Reports\/(?<pbiCollectionName>.*)_(?<reportName>.*)/)
  
    return {
      reportName: (matches && (matches.groups!.reportName || matches[1])) || "",
      pbiCollectionName: (matches && (matches.groups!.pbiCollectionName || matches[2])) || "",
    }
  }